import { Role } from "../../../helpers/role";
export const ManagementMenu = [
  {
    title: "OLT List",
    icon: "mdi-access-point-network",
    to: "olt-list",
    code: "olt-list",
    role: [Role.Management],
  },
  {
    title: "AP List",
    icon: "mdi-access-point",
    to: "ap-list",
    code: "ap-list",
    role: [Role.Management],
  },

  {
    title: "Search ONU",
    icon: "mdi-card-search-outline",
    to: "search-onu",
    code: "ap-list",
    role: [Role.Management],
  },

  {
    title: "Check OLT",
    icon: "mdi-check-network-outline",
    to: "check-olt",
    code: "check-olt",
    role: [Role.Management],
  },

  {
    title: "Search Payment",
    icon: "mdi-credit-card-search-outline",
    to: "search-payment",
    code: "ap-list",
    role: [Role.Management],
  },
  {
    title: "Release ONU",
    icon: "mdi-cog-refresh-outline",
    to: "release-onu",
    code: "release-onu",
    role: [Role.Management],
  },

  {
    title: "Change ONU",
    icon: "mdi-briefcase-arrow-left-right-outline",
    to: "change-onu",
    code: "release-onu",
    role: [Role.Management],
  },
  {
    title: "Check Reference",
    icon: "mdi-timeline-check-outline",
    to: "check-reference",
    code: "release-onu",
    role: [Role.Management],
  },
  {
    title: "Activation List",
    icon: "mdi-text-box-check-outline",
    to: "activation-list",
    code: "release-onu",
    role: [Role.Management],
  },
];
